import { render, staticRenderFns } from "./PreviewCardHeader.vue?vue&type=template&id=146cdd4d&scoped=true"
import script from "./PreviewCardHeader.vue?vue&type=script&lang=js"
export * from "./PreviewCardHeader.vue?vue&type=script&lang=js"
import style0 from "./PreviewCardHeader.vue?vue&type=style&index=0&id=146cdd4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146cdd4d",
  null
  
)

export default component.exports